import { Component, computed, inject, input } from '@angular/core';
import { IconButtonComponent } from 'projects/shared/src/ui-kit/button/components/icon-button/icon-button.component';
import { DialogModule } from 'primeng/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { DialogService } from 'projects/shared/src/lib/core/services/dialog.service';

@Component({
  selector: 'tar-dialog',
  imports: [IconButtonComponent, DialogModule, TranslatePipe],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
})
export class DialogComponent {
  public dialogService = inject(DialogService);

  public draggable = input<boolean>(true);
  public key = input<string>('');

  public title = computed(() => this.dialogService.dialogData()?.title ?? '');
  public description = computed(() => this.dialogService.dialogData()?.description ?? '');
  public descriptionParams = computed(() => this.dialogService.dialogData()?.descriptionParams);
  public actions = computed(() => this.dialogService.dialogData()?.actions ?? []);
  public visible = computed(() => this.dialogService.visible() === this.key())

  public onVisibleChange(value: boolean): void {
    if (!value) {
      this.dialogService.close();
    }
  }

  public close() {
    this.dialogService.close();
  }
}
